





















import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import { Component, Prop } from 'vue-property-decorator';

import { AdminMenuData, FeatureSwitches, Quiz, User } from 'frontend/types';
import { populateAdminMenu } from 'frontend/utils/admin';
import AdminMenu from 'frontend/components/AdminMenu.vue';
import GoogleClassroomButton from 'frontend/views/courses/components/GoogleClassroomButton.vue';
import { googleClassroomSetup } from 'frontend/views/courses/CoursePage/utils/googleClassroomSetup';

@Component({
  components: { AdminMenu, GoogleClassroomButton },
  computed: {
    ...mapState('globals', ['user']),
    ...mapGetters('globals', ['featureSwitches']),
    ...mapGetters('response', ['baseUrl']),
  },
})
export default class LessonAdmin extends Vue {
  @Prop({ type: Object, required: true })
  private lesson!: Quiz;

  private readonly user!: User;
  private readonly featureSwitches!: FeatureSwitches;
  private readonly baseUrl!: string;

  private isGoogleClassroomsReadyToRender: boolean = false;

  private get adminMenu(): AdminMenuData | null {
    return this.buildAdminMenuForLesson(this.lesson);
  }

  private get shouldShowGoogleClassroomButton(): boolean {
    return this.user.is_classroom_teacher && !!this.featureSwitches.enable_google_classrooms;
  }

  private mounted(): void {
    if (this.shouldShowGoogleClassroomButton) {
      googleClassroomSetup.loadScript(() => (this.isGoogleClassroomsReadyToRender = true));
    }
  }

  private buildAdminMenuForLesson(lesson: Quiz): AdminMenuData | null {
    const isLesson = lesson.version_id !== null;
    const adminMenu = populateAdminMenu(
      lesson,
      isLesson ? 'lesson' : 'quiz',
      undefined,
      this.featureSwitches.use_retool_campgrounds,
    );

    if (isLesson && adminMenu?.items) {
      adminMenu.items.push(`Lesson id: ${lesson.quiz_id}`);
      adminMenu.items.push(`Version name: ${lesson.version_name}`);
    }

    return adminMenu;
  }
}
